import { cn } from "@/lib/cn";

type BadgeVariant = "primary" | "neutral" | "danger";

type BadgeProps = {
    label: string;
    variant?: BadgeVariant;
    className?: string;
};

const variantClasses: Record<BadgeVariant, string> = {
    primary: "bg-primary text-white",
    neutral: "bg-gray-100 text-gray-600",
    danger: "bg-red-500 text-white",
};

export function Badge({ label, variant = "primary", className }: BadgeProps) {
    return (
        <span
            className={cn(
                "rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase",
                variantClasses[variant],
                className,
            )}
        >
            {label}
        </span>
    );
}
